import { render } from "./InvoiceReader.vue?vue&type=template&id=ef9cc0ae"
import script from "./InvoiceReader.vue?vue&type=script&lang=js"
export * from "./InvoiceReader.vue?vue&type=script&lang=js"

import "./InvoiceReader.vue?vue&type=style&index=0&id=ef9cc0ae&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__